import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      options: []
    };
  },
  props: {
    value: {
      default: ''
    },
    size: {
      default: 'small'
    }
  },
  computed: {
    listeners: function listeners() {
      var _this = this;

      return _objectSpread(_objectSpread({}, this.$listeners), {}, {
        // Override input listener to work with v-model
        input: function input(event) {
          return _this.$emit('input', event);
        }
      });
    }
  }
};